import JSZip from 'jszip';
import html2canvas from "html2canvas";
import { mimetypes } from "../../common/mimetypes";
import { tagMap } from '../../common/htmlFigmaTagMap';
import { formatBytes, getHeightAndWidthFromDataUrl, getPreviewAndSizeFromFile } from '../helper';

export async function handleImageLoad(file, mimetypes) {
  if (mimetypes.includes(file.type)) {
    file = await getPreviewAndSizeFromFile(file);
    return [file];
  } else if (file.type === "application/zip") {
    const fileArr = [];
    const zip = new JSZip();
    const zipData = await zip.loadAsync(file);
    const zipFiles = Object.values(zipData.files);
    if (zipFiles.length > 0) {
      let i = 0;
      do {
        const fileBlob = await zipFiles[i].async("blob");
        let fileEntry = new File([fileBlob], zipFiles[i].name, { type: "image/" + zipFiles[i].name.split(".")[1] })
        fileEntry = await getPreviewAndSizeFromFile(fileEntry);
        fileArr.push(fileEntry);
        i++;
      } while (i < zipFiles.length);
    }
    return fileArr;
  }
}

export async function handleHtmlLoad(file) {
  if (file.type === "application/zip") {
    const zip = new JSZip();
    const zipData = await zip.loadAsync(file);
    const zipFiles = Object.values(zipData.files);
    if (zipFiles.length > 0) {
      const htmlFiles = await extractHtmlFromZip(zipFiles);
      const htmlObjs = await loopHtmlFilesToConvert(htmlFiles, zipFiles, file);
      return htmlObjs;
    }
  }
  // else {
  //   const htmlObj = [];
  //   const obj = await convertHtmlToObj(file);
  //   htmlObj.push({ figma: obj.figma, size: `${obj.figma.frame.width}X${obj.figma.frame.height}` });
  //   console.log(htmlObj);
  //   return htmlObj;
  // }
}

async function extractHtmlFromZip(zipFiles) {
  const htmlFiles = [];
  let i = 0;
  do {
    let zipEntry = zipFiles[i];
    if (zipEntry.name.endsWith(".html")) {
      htmlFiles.push(zipEntry);
    }
    i++;
  } while (i < zipFiles.length);
  return htmlFiles;
}

async function loopHtmlFilesToConvert(htmlFiles, zipFiles, file) {
  let htmlObjs = [];
  let k = 0;
  do {
    const htmlFile = htmlFiles[k];
    const content = await htmlFile.async('blob');
    const type = determineFileType(htmlFile.name);
    const blob = { name: htmlFile.name, blob: content, type: type };
    const convertedFile = new File([blob.blob], blob.name, { type: blob.type });
    const obj = await convertHtmlToObj(htmlFile, zipFiles);
    htmlObjs.push({
      preview: obj.thumbnail,
      figma: {node: obj.node, animation: obj.animation},
      pixelSize: `${obj.node.frame.width}x${obj.node.frame.height}`,
      formattedSize: formatBytes(htmlFile._data.uncompressedSize),
      name: htmlFile.name,
      type: "HTML",
      status: 1,
      file: convertedFile,
      zip: file
    });
    k++;
  } while (k < htmlFiles.length);
  return htmlObjs;
}


async function convertHtmlToObj(file, zipFiles) {
  return new Promise(async (resolve, reject) => {
    const htmlBlob = await file.async("blob");
    const reader = new FileReader();
    reader.readAsText(htmlBlob);
    reader.onload = async (e) => {
      const htmlStr = e.target.result;
      const html = document.createElement('html');
      html.innerHTML = htmlStr;
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.zIndex = "-9999";
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.visibility = 'hidden';
      iframe.style.transform = 'scale(0)';
      document.body.appendChild(iframe);
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      await getCssFiles(zipFiles, html);
      await getJsFiles(zipFiles, html);
      iframeDoc.open();
      iframeDoc.write(html.innerHTML);
      iframeDoc.close();
      iframe.contentWindow.onload = async () => {
        let rootElement = ``;
        if (iframeDoc.body.children[0].tagName.includes('GWD')) {
          rootElement = iframe.contentWindow.document.body.querySelector(`gwd-page`);
        } else {
          rootElement = iframe.contentWindow.document.body.children[0];
        }
        let htmlObj = {};
        await loopThroughElements(rootElement, zipFiles, [], htmlObj);
        htmlObj.frame = {
          frameId: `container`,
          name: file.name.replace(`.html`, ``),
          width: rootElement.offsetWidth,
          height: rootElement.offsetHeight,
          css: { ...htmlObj['0'].css },
          fonts: 'Poppins:normal:400||'
        };
        htmlObj.container = {};
        htmlObj.container.type = 'INSTANCE';
        htmlObj.container.name = 'container';
        htmlObj.container.id = 'container';
        htmlObj.container.htmlId = 'idcontainer';
        htmlObj.container.css = { ...htmlObj['0'].css };
        htmlObj.container.elements = [{ htmlId: 'id0', id: '0', name: 'Container', type: `INSTANCE` }];
        htmlObj[`background`] = {};
        htmlObj[`background`].type = `RECTANGLE`;
        htmlObj[`background`].name = `background`;
        htmlObj[`background`].id = `background`;
        htmlObj[`background`].htmlId = `idbackground`;
        htmlObj[`background`].elements = [];
        htmlObj[`background`].css = { ...htmlObj['0'].css, 'position': 'absolute', 'top': '0px', 'left': '0px', 'z-index': `-1` };
        htmlObj[`background`].bgimages = htmlObj['0'].bgimages;
        htmlObj['0'].elements = [
          {
            htmlId: htmlObj[`background`].htmlId,
            id: htmlObj[`background`].id,
            name: htmlObj[`background`].name,
            type: htmlObj[`background`].type,
          },
          ...htmlObj[`0`].elements
        ];
        const thumbnail = await getTemplateThumbnail(rootElement);
        const animObj = {
          "duration": 10,
          "slider": {},
          "pictures": {
            "frameImage0": {
              "position": 0,
              "width": -8,
              "time": "0",
              "html": {}
            }
          }
        }
        iframe.remove();
        resolve({ node: htmlObj, animation: animObj, thumbnail: thumbnail });
      }
    }
  });
}

async function getTemplateThumbnail(html) {
  return html2canvas(html, {
    allowTaint: true,
    useCORS: true,
    logging: true
  }).then(canvas => {
    const img = canvas.toDataURL("image/jpeg");
    return img;
  })
}

export function determineFileType(filename) {
  const extension = filename.split('.').pop().toLowerCase();
  return mimetypes[extension] || 'application/octet-stream';
}

async function getCssFiles(zipFiles, html) {
  const links = html.querySelectorAll("link[rel='stylesheet']");
  for (const link of links) {
    let css = '';
    let cssFileName = link.href.split('/');
    let i = 0;
    do {
      if (zipFiles[i].name.match(cssFileName[cssFileName.length - 1])) {
        css = await zipFiles[i].async('text');
        break;
      }
      i++;
    } while (i < zipFiles.length);
    if (css !== '') {
      const style = document.createElement('style');
      style.appendChild(document.createTextNode(css));
      link.parentNode.replaceChild(style, link);
    }
  }
}

async function getJsFiles(zipFiles, html) {
  const scripts = html.querySelectorAll('script');
  for (const script of scripts) {
    let scriptStr = '';
    if (script.src) {
      let jsFileName = script.src.split('/');
      let i = 0;
      do {
        if (zipFiles[i].name.match(jsFileName[jsFileName.length - 1])) {
          scriptStr = await zipFiles[i].async('text');
          break;
        }
        i++;
      } while (i < zipFiles.length);
    } else {
      scriptStr = script.innerText;
    }
    if (scriptStr !== '') {
      const scriptTag = document.createElement('script');
      const jsBlob = new Blob([scriptStr], { type: 'text/javascript' });
      const url = URL.createObjectURL(jsBlob);
      scriptTag.src = url;
      script.parentNode.replaceChild(scriptTag, script);
    }
  }
}

async function loopThroughElements(element, zipFiles, path = [], htmlObj) {
  let currentPath;
  try {
    currentPath = [...path, Array.prototype.indexOf.call(element.parentNode.children, element)];    
  } catch (error) {
    currentPath = [...path];
  }
  let uniqueId = currentPath.join(`:`);
  let obj = {
    id: uniqueId,
    htmlId: `id` + uniqueId.replaceAll(':', '_').replaceAll(';', '_'),
    css: await getElementStyles(element),
    elements: []
  };
  element.id = uniqueId;

  let type = await classifyElementType(element);
  obj = { ...obj, ...type };
  if (element.src || (obj.css[`background-image`] && obj.css[`background-image`] !== `none` && obj.css[`background-image`] !== `initial`)) {
    obj.bgimages = await handleImageElement(element, obj, zipFiles);
  }

  if (element.children.length > 0) {
    let i = 0;
    do {
      const child = element.children[i];
      if (child.tagName.toUpperCase() !== 'BR') {
        let childObj = await loopThroughElements(child, zipFiles, currentPath, htmlObj);
        if (childObj) {
          obj.elements.push(childObj);
        }
      }
      i++;
    } while (i < element.children.length);
  }

  if (obj.type === 'VECTOR' && element.tagName.toUpperCase() !== 'SVG') {
    return null;
  } else {
    htmlObj[obj.id] = { ...obj };
    return { htmlId: obj.htmlId, id: obj.id, name: obj.name, type: obj.type };
  }
}

async function getElementStyles(element) {
  const computedStyles = window.getComputedStyle(element);
  const inlineStyles = element.style;
  const result = {};

  for (let i = 0; i < inlineStyles.length; i++) {
    const propName = inlineStyles[i];
    result[propName] = computedStyles.getPropertyValue(propName);
  }

  const stylesheetStyles = {};
  const allStylesheets = Array.from(element.ownerDocument.styleSheets);
  const allStyleElements = element.ownerDocument.querySelectorAll('style');

  allStyleElements.forEach(style => {
    allStylesheets.push(style.sheet);
  });

  allStylesheets.forEach((stylesheet) => {
    try {
      if (stylesheet.href === null) {
        const rules = stylesheet.cssRules || stylesheet.rules;
        Array.from(rules).forEach((rule) => {
          if (rule.selectorText && element.matches(rule.selectorText)) {
            Array.from(rule.style).forEach((styleProp) => {
              stylesheetStyles[styleProp] = rule.style[styleProp];
            });
          }
        });
      }
    } catch (e) {
      // console.log(`Stylesheet could not be accessed: ${e}`);
    }
  });

  const allStyles = { ...stylesheetStyles, ...result };
  allStyles['box-sizing'] = computedStyles.getPropertyValue('box-sizing');
  return allStyles;
}

async function findImage(zipFiles, imageName) {
  let i = 0;
  try {
    do {
      let zipEntry = zipFiles[i];
      if (zipEntry.name === imageName) {
        return zipEntry;
      }
      i++;
    } while (i < zipFiles.length);
  } catch (error) {
    return false;
  }
}

async function classifyElementType(element) {
  const elTagName = element.tagName.toUpperCase();
  const obj = {};
  obj.name = element.dataset.name || elTagName;
  if (tagMap[elTagName] === `TEXT`) {
    obj.type = `TEXT`;
    obj.name = element.innerText;
    obj.characters = element.innerHTML;
  } else if (tagMap[elTagName] === `RECTANGLE`) {
    if (element.children.length > 0) {
      obj.type = `INSTANCE`;
    } else {
      obj.type = `RECTANGLE`;
    }
  } else if (tagMap[elTagName] === `VECTOR`) {
    if (elTagName === `SVG`) {
      // obj.type = `GROUP`;
      obj.type = 'VECTOR';
      const fakeElement = document.createElement('div');
      fakeElement.innerHTML = element.outerHTML;
      fakeElement.firstElementChild.style.position = 'static';
      obj.svg = fakeElement.firstElementChild.outerHTML;
    }
    //  else {
    //   obj.type = `VECTOR`;
    //   obj.svg = element.parentElement.outerHTML;
    // }
  }
  return obj;
}

async function handleImageElement(element, obj, zipFiles) {
  let bgObj = { '1x': { name: '', data: '', size: {} } };
  let imageName = '';
  if (element.src) {
    // let source = (element.src ? element.src : element.attributes.source.value);
    let source = element.src;
    let url = window.location.href.split('/');
    url.pop();
    url = url.join('/');
    if (source.includes(url)) {
      imageName = source.replace(url, '');
      imageName = imageName.substring(1, imageName.length);
    } else {
      imageName = source;
    }

  } else {
    const backgroundCss = obj.css['background-image'];
    const match = backgroundCss.match(/url\((.*?)\)/);
    if (match) {
      if (match[1].includes('http')) {
        imageName = match[1];
      } else {
        // imageName = match[1].split('/').pop();
        imageName = match[1].replace(/"/g, '');
      }
    }
  }

  // Clean up imageName
  imageName = imageName.replace(/"/g, '');
  bgObj['1x'].name = imageName;
  // Search image in zipFiles and convert to base64
  const foundImage = await findImage(zipFiles, imageName);
  let image = '';
  if (foundImage) {
    const newBlob = new Blob([foundImage._data.compressedContent]);
    const file = new File([newBlob], foundImage.name, { type: 'image/' + imageName.split('.').pop() });
    image = await foundImage.async('base64')
      .then(content => {
        let extension = getImageExtension(imageName);
        return `data:${extension};base64,${content}`;
      });
  } else {
    image = imageName;
  }
  bgObj = await setImageSize(bgObj, obj, element, image, imageName);
  return bgObj;
}

async function setImageSize(bgObj, obj, element, image, imageName) {
  if (element.src || (element.tagName.toUpperCase().includes('GWD') || element.parentElement.tagName.toUpperCase().includes('GWD'))) {
    if (element.parentElement.parentElement.attributes.source) {
      element.parentElement.parentElement.setAttribute('source', image);
    }
    element.src = image;
    const canvas = document.createElement('canvas');
    canvas.width = element.scrollWidth;
    canvas.height = element.scrollHeight;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = image;
    img.width = element.scrollWidth;
    img.height = element.scrollHeight;
    img.crossOrigin = 'anonymous';
    img.onload = async () => {
      ctx.drawImage(img, 0, 0, element.scrollWidth, element.scrollHeight);
      let bg64 = canvas.toDataURL();
      canvas.remove();
      img.remove();
      bgObj['1x'].data = bg64;
      bgObj['1x'].size.width = element.scrollWidth;
      bgObj['1x'].size.height = element.scrollHeight;
      obj.css.width = element.scrollWidth + 'px';
      obj.css.height = element.scrollHeight + 'px';
      obj.css['min-height'] = element.scrollHeight + 'px';
    }
  } else if (obj.css['background-image']) {
    const bg64 = await elementBgToBase64(element, image, obj);
    element.style.backgroundImage = `url(${bg64})`;
    const pixelSize = await getHeightAndWidthFromDataUrl(bg64);
    const [width, height] = pixelSize.split('x').map(Number);
    bgObj['1x'].size.width = width;
    bgObj['1x'].size.height = height;
    bgObj['1x'].data = bg64;
    obj.css.width = width + 'px';
    obj.css.height = height + 'px';
    obj.css['min-height'] = height + 'px';
    obj.css['background-image'] = `url(${bg64})`;
  }

  return bgObj;
}

// Converts an element's background image to a Base64 encoded string.
async function elementBgToBase64(element, image, obj) {
  return new Promise((resolve, reject) => {
    if (image.includes('http')) {
      return resolve(image);
    }
    const bgSize = obj.css['background-size'] ? obj.css['background-size'] : null;
    const elementWidth = element.offsetWidth;
    const elementHeight = element.offsetHeight;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = image;
    img.onload = () => {
      let drawWidth, drawHeight, offsetX, offsetY;
      const scale = Math.min(elementWidth / img.width, elementHeight / img.height);
      drawWidth = img.width * scale;
      drawHeight = img.height * scale;
      offsetX = (elementWidth - drawWidth) / 2;
      offsetY = (elementHeight - drawHeight) / 2;
      canvas.width = elementWidth;
      canvas.height = elementHeight;
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      let base64 = canvas.toDataURL();
      canvas.remove();
      img.remove();
      resolve(base64);
    }
  });
}

function getImageExtension(imageName) {
  let extension = imageName.split('.').pop();
  if (extension === 'svg') {
    return 'image/svg+xml';
  } else {
    return `image/${extension}`;
  }
}